export default __webpack_public_path__ + "static/media/no-approved.272d2324.svg";